import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ApproveCommentDialogData } from '../approve-comment-dialog/approve-comment-dialog-data';
import { ApproveCommentDialogComponent } from '../approve-comment-dialog/approve-comment-dialog.component';

@Injectable()
export class ApproveCommentDialogService {
    constructor(private dialog: MatDialog) { }

    matDialogRef: MatDialogRef<ApproveCommentDialogComponent>;

    open(approveCommentDialogData: ApproveCommentDialogData) {
        const matDialogConfig = new MatDialogConfig();
        matDialogConfig.panelClass = 'myapp-dialog';
        matDialogConfig.width = '30em';
        matDialogConfig.data = approveCommentDialogData;
        matDialogConfig.disableClose = false;
        matDialogConfig.hasBackdrop = true;
        this.matDialogRef = this.dialog.open(ApproveCommentDialogComponent, matDialogConfig);
    }

    confirmed(): Observable<any> {
        return this.matDialogRef.afterClosed().pipe(
            take(1),
            map(res => {
                return res;
            })
        );
    }
}
